export default __webpack_public_path__ + "static/media/case_study_5.42fb99d9.jpg";